import {AddToolboxAnnotation, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalRubberStampAnnotation} from "./PortalRubberStampAnnotation";
import {PortalRedactAnnotation} from "./PortalRedactAnnotation";

export class PortalAddToolboxAnnotation extends AddToolboxAnnotation implements Parameter {
	public rubberstamp: Array<PortalRubberStampAnnotation>;
	public redact: Array<PortalRedactAnnotation>

	constructor(data: any) {
		super(data);

		this.rubberstamp = FunctionHelper.applyValue(
			data.rubberstamp, PortalAddToolboxAnnotation.getRubberstampDefault()
		).map(PortalRubberStampAnnotation.fromJson);
		this.redact = FunctionHelper.applyValue(
			data.redact, PortalAddToolboxAnnotation.getRedactDefault()
		).map(PortalRedactAnnotation.fromJson);
	}

	public static getRubberstampDefault(): Array<PortalRubberStampAnnotation> {
		return [];
	}

	public static getRedactDefault(): Array<PortalRedactAnnotation> {
		return [];
	}

	public static fromJson(data: any): PortalAddToolboxAnnotation {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalAddToolboxAnnotation(data);
	}

	public clone(): PortalAddToolboxAnnotation {
		return PortalAddToolboxAnnotation.fromJson(this.toJson());
	}
}